module.exports = __webpack_public_path__ + "static/img/zhhq8.bb200e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zhhq8.png
// module id = BMDq
// module chunks = 1